import { useState } from 'react';
import { TBaseObj } from '../types/sitecore.types';
import { windowService } from '../utils/window.utils';
import { useNavigate } from 'react-router';

const getQuery = () => new URLSearchParams(windowService().location?.search);

const getQueryStringVal = (key: string): string | null => getQuery().get(key);

const useQueryParams = (key: string, defaultVal: string): [string, (val: string) => void] => {
  const navigate = useNavigate();
  const [query, setQuery] = useState(getQueryStringVal(key) || defaultVal);

  const updateUrl = (newVal: string) => {
    setQuery(newVal);

    const newQuery = getQuery();

    if (newVal.trim() !== '') {
      newQuery.set(key, newVal);
    } else {
      newQuery.delete(key);
    }

    navigate(`?${newQuery.toString()}`);
  };

  return [query, updateUrl];
};

export const setBulkQueryParamsAndRedirect = (obj: TBaseObj, url = '') => {
  if (!obj) return;
  const queries = getQuery();
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (value.trim() !== '') {
      queries.set(key, value);
    } else {
      queries.delete(key);
    }
  });

  // reload the page with updated search params
  const anchorElement = document.createElement('a');
  const baseUrl = url.split('?')?.[0] || '';
  anchorElement.href = baseUrl + '?' + (queries.toString() || '');
  anchorElement.click();
};

export const updateSearchResults = (navigate: any, obj: TBaseObj, url = '') => {
  if (!obj || !navigate) return;
  const queries = getQuery();
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (value.trim() !== '') {
      queries.set(key, value);
    } else {
      queries.delete(key);
    }
  });

  // reload the page with updated search params
  const baseUrl = url.split('?')?.[0] || '';
  const searchUrl = baseUrl + '?' + (queries.toString() || '');
  navigate(searchUrl);
};

export default useQueryParams;
